import React, { useState, useEffect } from "react";
import "./Separation.css";
import config from "../../config";



const TerminationPopup = ({ employee, assets, onClose, onSuccess }) => {
  const [terminatedBy, setTerminatedBy] = useState("");
  const [reason, setReason] = useState("");
  const [noticePeriod, setNoticePeriod] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [noticePeriodOptions, setNoticePeriodOptions] = useState([]);

  useEffect(() => {
    fetchNoticePeriods();
  }, []);

  const fetchNoticePeriods = async () => {
    try {
      const token = localStorage.getItem("Authorization");
      const orgId = localStorage.getItem("orgId");
      if (!token || !orgId) return;

      const res = await fetch(
        `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=NoticePeriod`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (res.ok) {
        const data = await res.json();
        const activeOptions = data
          .filter((item) => item.isActive)
          .map((item) => item.values);
        setNoticePeriodOptions(activeOptions);
      }
    } catch (err) {
      console.error("Failed to fetch notice periods:", err);
    }
  };

  const handleTerminate = async () => {
    if (!terminatedBy || !noticePeriod) {
      setError("Please fill in all required fields.");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const token = localStorage.getItem("Authorization");
      const orgId = localStorage.getItem("orgId");

      const payload = {
        orgKey: Number(orgId),
        clientKey: Number(employee?.clientKey || employee?.client || 0),
        emailAddress: employee?.emailAddress || employee?.email || "",
        status: "InActive",
        terminateExitStatus: "Terminated",
        terminatedBy,
        reason,
        noticePeriod,
        assets: assets || [],
      };

      const res = await fetch(
        `${config.API_BASE_URL}${config.UPDATE_EMPLOYEE_STATUS_ENDPOINT}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        onSuccess && onSuccess();
      } else {
        const data = await res.json();
        setError(data.message || "Failed to terminate employee.");
      }
    } catch (err) {
      console.error("Termination error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sep-modal-overlay" onClick={onClose}>
      <div className="sep-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Termination</h2>

        {error && (
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: "linear-gradient(135deg, #fff5f5 0%, #fff1f1 100%)",
            border: "1px solid #fecaca",
            borderLeft: "4px solid #dc2626",
            color: "#b91c1c",
            padding: "10px 14px",
            borderRadius: "8px",
            fontSize: "13px",
            fontWeight: 500,
            marginBottom: "16px",
            boxShadow: "0 1px 4px rgba(220,38,38,0.08)",
          }}>
            <span style={{ fontSize: "16px", flexShrink: 0 }}>⚠️</span>
            <span>{error}</span>
          </div>
        )}

        <div className="sep-modal-field">
          <label>Terminated By</label>
          <input
            type="text"
            value={terminatedBy}
            onChange={(e) => setTerminatedBy(e.target.value)}
            placeholder="Enter terminated by..."
          />
        </div>

        <div className="sep-modal-field">
          <label>Reason</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason..."
          />
        </div>

        <div className="sep-modal-field">
          <label>Notice period</label>
          <select
            value={noticePeriod}
            onChange={(e) => setNoticePeriod(e.target.value)}
          >
            <option value="">Select</option>
            {noticePeriodOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>

        <div className="sep-modal-actions">
          <button className="sep-modal-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="sep-modal-confirm"
            onClick={handleTerminate}
            disabled={loading}
          >
            {loading ? "Processing..." : "Terminate"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TerminationPopup;
